export default __webpack_public_path__ + "static/media/attention-bell-ding.7fa9554f.wav";